// Interruptor de las secciones nuevas (§1 bis.7). Vive al pie de Personas y
// sólo lo ve el dueño de la app (Ignacio): la base no deja a nadie más
// cambiarlo (migración 0022). Prender o apagar no requiere deploy: la app lo lee
// al entrar y se recarga para aplicarlo.

import { supabase } from "../../supabaseClient.js";
import { setColoniaFlag } from "../../lib/coloniaApi.js";
import { confirmDialog, escapeHtml } from "../../lib/ui.js";

const SWITCHES = [
  ["colonia_empresa", "Colonia nueva", "tarifario, inscripciones, cuotas y cobros"],
  ["colonia_tanda2", "Tanda 2", "Resumen, Equipo y sueldos, Ingresos y egresos de Colonia, la sección Empresa y los bloques nuevos del Panel y Alertas"],
];

export async function mountColoniaSwitch(container) {
  // Sólo el dueño de la app (0022) ve los interruptores. Si la base todavía
  // no tiene es_dueno(), no se muestran: nadie los ve antes que de más.
  const { data: dueno, error: errDueno } = await supabase.rpc("es_dueno");
  if (errDueno || dueno !== true) return;

  const { data, error } = await supabase.from("app_settings").select("key, enabled, updated_at");
  // Base sin la migración 0020: no hay nada que mostrar.
  if (error || !data || data.length === 0) return;
  const estado = Object.fromEntries(data.map((r) => [r.key, r]));
  const switches = SWITCHES.filter(([key]) => estado[key]);

  const panel = document.createElement("div");
  panel.className = "panel";
  panel.innerHTML = `
    <h3>Funciones nuevas</h3>
    ${switches
      .map(
        ([key, nombre, detalle]) => `
      <label class="checkbox-line">
        <input type="checkbox" data-flag="${key}" data-nombre="${escapeHtml(nombre)}" ${estado[key].enabled ? "checked" : ""} />
        <strong>${escapeHtml(nombre)}</strong> (${escapeHtml(detalle)})
      </label>
      <p class="hint">${estado[key].enabled ? "Prendida." : "Apagada."}
        ${estado[key].updated_at ? `Último cambio: ${escapeHtml(new Date(estado[key].updated_at).toLocaleString("es-AR"))}.` : ""}</p>`
      )
      .join("")}
    <p class="hint">Si algo falla, apagala acá y se vuelve a como estaba al instante. No se pierde nada de lo cargado.
      La Tanda 2 necesita la Colonia nueva prendida.</p>
    <p class="error-text" id="flag-error" hidden></p>`;
  (container.querySelector("#view") ?? container).appendChild(panel);

  panel.addEventListener("change", async (e) => {
    const key = e.target.dataset?.flag;
    if (!key) return;
    const on = e.target.checked;
    const nombre = e.target.dataset.nombre;
    const pregunta = on
      ? `¿Prender "${nombre}" para toda la familia (admin y Papá y Mamá)?`
      : `¿Apagar "${nombre}"? Lo cargado queda guardado.`;
    if (!confirmDialog(pregunta)) {
      e.target.checked = !on;
      return;
    }
    try {
      await setColoniaFlag(on, key);
      window.location.reload();
    } catch (err) {
      e.target.checked = !on;
      const el = panel.querySelector("#flag-error");
      el.textContent = err.message;
      el.hidden = false;
    }
  });
}
